var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone-display"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a',{attrs:{"href":("tel:" + (_vm.field.value))}},[_vm._v(_vm._s(_vm.field.value))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f70fd17a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/displays/PhoneDisplay.vue
// module id = 964
// module chunks = 1